import { Mail } from 'lucide-react';

export function LoginFooter() {
    return (
        <div className="flex justify-between items-center mt-auto">
            <div className='font-inter text-sm text-gray-600'>© Clearitty 2025</div>
            <div className="flex gap-1 items-center">
                <Mail className='w-4 text-gray-600' />
                <div className="font-inter text-sm text-gray-600">
                    <a href='mailto:help@clearitty.com' target='_blank'>help@clearitty.com</a>
                </div>
            </div>
        </div>
    );
}
